export const getIdBasedOnType = (type) => {
  if (type === 'Service-Client') {
    return 'clientId';
  } else if (type === 'Site') {
    return 'siteId';
  } else if (type === 'Corporate') {
    return 'corporateId';
  } else if (type === 'Company') {
    return 'companyId';
  }
};
